import { useCallback } from "react"

import { useReportFirstContactEventMutation } from "@/shared/api"
import type { OnboardingWebappEvent } from "@/shared/api"
import { getActiveOnboardingSession } from "@/shared/lib/onboarding-session"

interface MilestoneOptions {
  screen?: string | null
  chatId?: number | null
  action?: string | null
  once?: boolean
}

const firedOnce = new Set<string>()

export const useOnboardingMilestone = () => {
  const [report] = useReportFirstContactEventMutation()

  return useCallback(
    (event: OnboardingWebappEvent, options: MilestoneOptions = {}) => {
      const session = getActiveOnboardingSession()
      if (!session) return

      if (options.once) {
        const key = `${session.token}:${event}:${options.action ?? ""}`
        if (firedOnce.has(key)) return
        firedOnce.add(key)
      }

      report({
        button: session.button,
        event,
        chatId: options.chatId ?? null,
        correlationId: session.token,
        screen: options.screen ?? null,
        action: options.action ?? null
      })
        .unwrap()
        .catch(() => {})
    },
    [report]
  )
}
